import styled from 'styled-components';
import React from 'react';
import { Headline, TextButton, Divider, } from '@oneaudi/unified-web-components';
import { SYS_BREAKPOINT_MD, SYS_BREAKPOINT_XL } from '@oneaudi/unified-web-common';
export const OptionsToolbarContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: left;
  margin-top: var(--spacing-relative-lg);
  margin-bottom: var(--spacing-relative-lg);

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    &:last-child {
      margin-bottom: var(--spacing-relative-lg);
    }
  }
`;
export const MobileFavouritesHeading = styled((props) => (React.createElement(Headline, Object.assign({ tag: "h2", variant: {
        order: '1',
        type: 'headline',
        weight: 'normal',
    } }, props)))) `
  margin-top: var(--spacing-relative-lg);
  margin-bottom: var(--spacing-relative-2xl);
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: none;
  }
`;
export const DesktopFavouritesHeading = styled((props) => (React.createElement(Headline, Object.assign({ tag: "h2", variant: {
        order: '1',
        type: 'headline',
        weight: 'normal',
    } }, props)))) `
  display: none;
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: block;
    margin-bottom: var(--spacing-relative-2xl);
  }
`;
export const MobileOptions = styled.div `
  position: relative;

  @media (min-width: ${(props) => props.mandatoryAreaSearchActive ? SYS_BREAKPOINT_XL : SYS_BREAKPOINT_MD}) {
    display: none;
  }
`;
export const ButtonsWrapper = styled.div `
  display flex;
  flex-flow: row nowrap;
  justify-content: space-between;
`;
export const OptionsWrapper = styled.div `
  display: block;
  position: absolute;
  margin-top: var(--spacing-relative-2xs);
  background-color: #f2f2f2;
  z-index: 4;
  max-width: 100vw;
  left: -28px;
  right: -28px;
  padding-left: 28px;
  padding-right: 28px;

  @media (min-width: ${(props) => props.mandatoryAreaSearchActive ? SYS_BREAKPOINT_XL : SYS_BREAKPOINT_MD}px) {
    display: none;
  }
`;
export const StyledButton = styled((props) => React.createElement(TextButton, Object.assign({}, props))) `
  padding: var(--spacing-relative-sm) 0;
  ${(props) => props.mandatoryAreaSearchActive &&
    `
    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      width: unset;
    }`};
  }}

  > span {
   justify-content: left
  }
`;
export const StyledDivider = styled((props) => React.createElement(Divider, Object.assign({}, props))) `
  width: calc(100vw - 56px);
  ${(props) => props.mandatoryAreaSearchActive &&
    `
    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      width: unset;
    }`};
  }}
`;
export const DesktopOptions = styled.div `
  display: none;
  @media (min-width: ${(props) => props.mandatoryAreaSearchActive ? SYS_BREAKPOINT_XL : SYS_BREAKPOINT_MD}) {
    display: flex;
  }
`;
export const StyledText = styled((props) => (React.createElement(Headline, Object.assign({ tag: "h1", variant: {
        order: '1',
        type: 'headline',
        weight: 'normal',
    } }, props)))) `
  margin-bottom: var(--spacing-relative-3xl)
  overflow-wrap: anywhere;
  word-break: break-word;
  hyphens: auto;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin-bottom: unset;
  }
`;
